import { IActionsSetSignUpError } from "../actions/login";
import { LoginError } from "../thunks/login";

export const setSignUpError = (error: LoginError): IActionsSetSignUpError => {
  return {
    type: "SET_SIGN_UP_ERROR",
    error: error,
  };
};
